var DirectoriesUsa = {};

// indexOf function is not available in IE
// Just add it to the array prototype.
if(!Array.indexOf) {
    Array.prototype.indexOf = function(obj) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] == obj) {
                return i;
            }
        }
        return -1;
    };
}

// Adapted from http://stackoverflow.com/a/11638639/645511
window.console = window.console || (function () {
    var c = {};
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function () { };
    return c;
})();

function log(output) {
    if (typeof console != 'undefined')
        console.log(output);
}
